import React from "react";
import { NextImage } from "../NextImage";

export const MobilePreview = ({ index, type, title, width = 265, height = 508 }) => {
  return (
    <div
      key={index}
      className="Preview__box u-borderRadius-medium">
      <div className="Preview__image u-borderRadius-medium">
        <NextImage
          src={`/images/phone-previews/phone-${type}.png`}
          alt={`QR ${title} preview`}
          width={width}
          height={height}
          title={`QR ${title} preview`}
        />
      </div>
    </div>
  );
};
